module.exports = __webpack_public_path__ + "static/media/minus.572dad4d.svg";